import React, { useState } from "react";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, message, Modal, Upload } from "antd";
import Cropper from "react-easy-crop";
import { cropImage } from "../../../../utils/CropUtils";
import styles from "./InputUploader.module.css";
import { ACCEPTED_IMAGE_TYPE } from "../../../../constant";

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const InputUploader = ({
  cropped,
  lable,
  onChange,
  value,
  className,
  maxWidth,
  height,
  uploaderCss,
  listType,
  imgStyle,
}) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const handleOk = async () => {
    setLoading(true);
    const croppedImage = await cropImage(
      imageUrl,
      croppedAreaPixels,
      console.log
    );
    onChange(croppedImage);
    setTimeout(() => {
      setLoading(false);
      setModalOpen(false);
    }, 3000);
  };
  const handleCancel = () => {
    setModalOpen(false);
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const props = {
    beforeUpload: (file) => {
      if (!ACCEPTED_IMAGE_TYPE.includes(file?.type)) {
        message.error("Please upload profile in  png, jpeg or jpg format.");
        return;
      }
      getBase64(file, (url) => {
        setLoading(false);
        if (cropped) {
          setImageUrl(url);
          setModalOpen(true);
        } else {
          onChange(url);
        }
      });
      return false;
    },
  };

  return (
    <>
      <div className={className}>
        <div>{lable}</div>
        <Upload
          name="avatar"
          listType={listType || "picture-card"}
          className={`${styles.uploader} ${uploaderCss}`}
          showUploadList={false}
          {...props}
        >
          {value ? (
            <img
              src={value}
              alt="avatar"
              className={imgStyle}
              style={{
                width: "100%",
                height: height || "87px",
                maxWidth: maxWidth,
              }}
            />
          ) : (
            uploadButton
          )}
        </Upload>
      </div>
      <Modal
        open={modalOpen}
        title="Crop Header Image"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
          >
            Submit
          </Button>,
        ]}
      >
        <div className={styles.modal_content}>
          <Cropper
            image={imageUrl}
            crop={crop}
            zoom={zoom}
            aspect={6 / 1}
            onCropChange={setCrop}
            cropShape={"rect"}
            onCropComplete={(_, croppedAreaPixels) => {
              setCroppedAreaPixels(croppedAreaPixels);
            }}
            onZoomChange={setZoom}
            onComplete={(imagePromisse) => {
              imagePromisse.then((image) => {
                setDialogOpen(false);
              });
            }}
            open={dialogOpen}
          />
        </div>
      </Modal>
    </>
  );
};
export default InputUploader;
